// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fixed[data-v-367b6505]{position:fixed;background-color:#fff;z-index:5;right:70px;left:310px;top:160px}.internalUseMsg[data-v-367b6505]{display:block;margin:auto;text-align:right;font-style:italic}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
